export default __webpack_public_path__ + "static/media/ford.7716238a.svg";